import $ from 'jquery';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min'
import './css/styles';

$(function () {
	console.log("page loaded");
	$("#btn-download").on("click", () => $("#alert-downloading").hide().fadeIn());
});
